export default function randomString(len?: number, type?: 'numbers' | 'letters' | 'numLetters') {
	const LENGTH = len ?? 6;
	const TYPE = type ?? 'numLetters';
	const NUMBERS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
	const LETTERS = [
		'a',
		'b',
		'c',
		'd',
		'e',
		'f',
		'g',
		'h',
		'i',
		'j',
		'k',
		'o',
		'p',
		'q',
		'n',
		'm',
		'l',
		'r',
		's',
		't',
		'u',
		'v',
		'w',
		'x',
		'y',
		'z',
	];
	const NUMLETTER = [...NUMBERS, ...LETTERS];
	let codeArray = [];

	switch (TYPE) {
		case 'numbers':
			codeArray = NUMBERS;
			break;
		case 'letters':
			codeArray = LETTERS;
			break;
		case 'numLetters':
			codeArray = NUMLETTER;
			break;
	}

	const maxIndex = codeArray.length;

	let randomStr = '';
	for (let i = 0; i < LENGTH; i++) {
		randomStr += codeArray[Math.floor(Math.random() * maxIndex)];
	}
	return randomStr;
}
